module.exports = __webpack_public_path__ + "img/微信公众号3@2x.8ed72165.png";